<template>
   <div id="flight-basket-wrapper" v-if="basket">
      <div id="search-uuids-wrapper" v-if="showSearchUuids">
         <div class="search-uuid" v-for="(offer, offerIndex) in basket.offers" :key="offerIndex" @click="handlerCopySearchUuid(offer.searchUuid)">
            {{ offer.searchUuid }}
         </div>
      </div>
      <!-- {{ offer.searchUuid }} -->

      <div class="ticket-inner">
         <section class="ticket-header">
            <h2>
               {{ $t("basketComponentFlight_basket") }}
               <template v-if="offersCount == 1">
                  <template v-for="(offer, offerIndex) in basket.offers">
                     <div class="single-display-text" :key="offerIndex">
                        <span v-if="offer.tripType == 1">{{ $t("basketComponentFlight_single") }}</span>
                        <span v-else>{{ $t("basketComponentFlight_package") }} </span>
                     </div>
                  </template>
               </template>
            </h2>
            <div class="basket-type-switch" v-if="offersCount == 2">
               <span :class="step == 0 ? 'active-switch' : ''" @click="handlerUserMadeSelection(0)">{{ $t("basketComponentFlight_single") }} </span>
               <span :class="step == 1 ? 'active-switch' : ''" @click="handlerUserMadeSelection(1)">{{ $t("basketComponentFlight_package") }} </span>
            </div>
            <div class="dotted-line"></div>
         </section>

         <div class="fb-ticket-container">
            <Transition name="fade-checkout" mode="out-in">
               <template v-for="(offer, offerKey, offerIndex) in basket.offers">
                  <div class="fb-ticket" :key="offerIndex" v-if="offerIndex == step">
                     <div class="basket-offer">
                        <template v-if="offer.tripType == 2 && highlightSingle && offersCount != 1">
                           <div class="cheapest-offer-badge-wrapper" @click="step = 0" v-if="highlightSingle">
                              <span class="cheapest-offer-badge"> {{ $t("basketComponentFlight_singleOfferIsCheaper") }} </span>
                           </div>
                        </template>
                        <div class="basket-offer-leg-container">
                           <div class="basket-offer-leg" v-for="(leg, legIndex) in offer.legs" :key="legIndex">
                              <div class="basket-offer-segment">
                                 <div class="basket-offer-segment-infos">
                                    <span class="origin-airport">
                                       {{ leg.segments[0].originAirportCode }}
                                    </span>
                                    <i class="gts-icon icon-flight-icon icon-sm"></i>
                                    <span class="destination-airport">
                                       {{ leg.segments[leg.segments.length - 1].destinationAirportCode }}
                                    </span>
                                 </div>
                                 <div class="basket-offer-segment-price">
                                    <!-- <span class="leg-information" :class="leg.baggageInfo == '0KG' || leg.baggageInfo == '1PC' || leg.baggageInfo == '-1KG' ? 'attention' : 'no-attention'">
                                       <i class="gts-icon icon-ancillary-baggage icon-sm"></i>
                                       {{ leg.baggageInfo }}****
                                    </span> -->

                                    <span class="leg-information txt-small" v-if="leg.baggageInfo == '-1KG'">
                                       {{ $t("flightBrands_lblBaggageInfoUnknown") }}
                                    </span>
                                    <span class="leg-information" :class="leg.baggageInfo == '0KG' || leg.baggageInfo == '1PC' ? 'attention' : 'no-attention'" v-else>
                                       <i class="gts-icon icon-ancillary-baggage icon-sm"></i>
                                       {{ leg.baggageInfo }}
                                    </span>

                                    <span class="leg-price" v-if="leg.price > 0">{{ leg.price | price(leg.currency) }}</span>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <!-- {{ alertBeforeCheckout }} -->
                        <div class="action-button-wrapper" v-if="basket.checkoutEnabled">
                           <!-- alertBeforeCheckout TRUE -->
                           <template v-if="basket.checkoutEnabled && !alertBeforeCheckout">
                              <button @click="handlerCheckout(offer.searchUuid)">
                                 <div class="loader-arrow-wrapper">
                                    <i class="gts-icon icon-arrow-full icon-sm"></i>
                                 </div>

                                 <p class="total-container">
                                    <span class="total-text">{{ $t("basketComponentFlight_total") }}</span>
                                    <span class="total-price"> {{ offer.price | price(offer.currency) }}</span>
                                 </p>
                              </button>
                           </template>
                           <template v-else>
                              <div class="basket-alertbox-wrapper">
                                 <i></i>
                                 <span> {{ $t("basketComponentFlight_baggageInformationChanges") }} </span>
                                 <button id="confirm-changes" @click="alertBeforeCheckout = false">
                                    {{ $t("basketComponentFlight_btnBaggageInformationConfirmation") }}
                                 </button>
                              </div>
                           </template>

                           <button class="disabled-action" v-if="!basket.checkoutEnabled && basket.waitingForRtMlResponse">
                              <div class="loader-arrow-wrapper">
                                 <span class="g-radial-loader"></span>
                              </div>

                              <p class="total-container">
                                 <span class="total-text">{{ $t("basketComponentFlight_total") }}</span>
                                 <span class="total-price"> {{ offer.price | price(offer.currency) }}</span>
                              </p>
                           </button>
                        </div>
                        <div class="send-offer" @click="handlerDocumentViewer(2, offer.searchUuid)">
                           {{ $t("basketComponentFlight_sendOffer") }}
                        </div>
                     </div>
                     <section class="ticket-details-wrapper">
                        <div class="leg-offer-wrapper">
                           <div class="leg-offer-container" v-for="(leg, lindex) in offer.legs" :key="lindex">
                              <div class="leg-tab" @click="handlerLegToggler($event, lindex)">
                                 <!-- LEG MAIN -->
                                 <div class="leg-tab-main">
                                    <div class="leg-tab-left">
                                       <span class="leg-number">{{ leg.index }}</span>
                                       <span class="leg-header"> {{ leg.route }}</span>
                                    </div>

                                    <div class="leg-tab-right">
                                       <i class="gts-icon icon-detail-arrow icon-xs"></i>
                                    </div>
                                 </div>
                                 <!-- LEG DETAIL -->
                                 <!-- <div class="leg-tab-detail" :class="InitialToggle(basket.paxes) ? 'show-leg-tab-detail' : ''"> -->
                                 <div class="leg-tab-detail">
                                    <div class="leg-tab-detail-row" v-for="(segment, sindex) in leg.segments" :key="sindex">
                                       <div class="leg-tab-segment-wrapper">
                                          <div class="leg-tab-segment-row">
                                             <span>{{ segment.originAirportCode }} - {{ segment.destinationAirportCode }}</span>
                                             <span
                                                >{{ segment.departureDateTime | TimeFormat }} -
                                                {{ segment.arrivalDateTime | TimeFormat }}
                                             </span>
                                          </div>
                                          <div class="leg-tab-segment-row opacity">
                                             <span class="segment-flight-number">
                                                {{ segment.flightNumber }} -
                                                {{ segment.flightClass }}
                                             </span>
                                             <span class="segment-flight-date">
                                                {{ leg.date | basketDate }}
                                             </span>
                                          </div>
                                       </div>
                                    </div>

                                    <!-- PRICE BREAKDOWN -->
                                    <div class="leg-tab-detail-pax-breakdown" v-if="ShowPaxesBreakdown(basket.paxes)">
                                       <div class="leg-tab-detail-pax-breakdown-item" v-for="(item, index) in sortedPrices(leg.prices)" :key="item.key + index">
                                          <template v-if="item.key != 'ALL'">
                                             <span>{{ basket.paxes[item.key] }} {{ $t(`basketComponentFlight_lblPrice${item.key}`) }}</span>
                                             <span>{{ item.value | price(leg.currency) }}</span>
                                          </template>
                                          <template v-else>
                                             <span></span>
                                             <span class="legtotal">{{ item.value | price(leg.currency) }}</span>
                                          </template>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <div class="price-breakdown-noprice-view" v-if="!offer.pricePerLeg && showPriceBreakdown">
                           <h3>{{ $t(`basketComponentFlight_lblPriceBreakdown`) }}</h3>
                           <ul>
                              <li v-for="(item, index) in sortedPrices(offer.prices)" :key="index">
                                 <template v-if="item.key != 'ALL'">
                                    <span>{{ basket.paxes[item.key] }} {{ $t(`basketComponentFlight_lblPrice${item.key}`) }}</span>
                                    <span>{{ item.value | price(Object.keys(basket.offers)[0].currency) }}</span>
                                 </template>
                                 <template v-else>
                                    <span></span>
                                    <span class="legtotal">{{ item.value | price(Object.keys(basket.offers)[0].currency) }}</span>
                                 </template>
                              </li>
                           </ul>
                        </div>

                        <div class="send-offer" @click="showPriceBreakdown = !showPriceBreakdown" v-if="!offer.pricePerLeg">
                           <template v-if="!showPriceBreakdown">
                              {{ $t("basketComponentFlight_showPriceBreakdown") }}
                           </template>
                           <template v-else>
                              {{ $t("basketComponentFlight_hidePriceBreakdown") }}
                           </template>
                        </div>
                     </section>
                  </div>
               </template>
            </Transition>
         </div>
      </div>

      <PaxConnectButton v-if="basket.checkoutEnabled" :offerSuccess="offerSuccess" :showSubtitle="true" @click="handlerCreateOffer" />
   </div>
</template>

<script>
import PaxConnectButton from "@/components/common/PaxConnectButton.vue";
import { handleCreateOffer } from "@/helper/offerHelper.js";

export default {
   name: "FlightBasket",
   components: {
      PaxConnectButton,
   },
   props: {
      basket: Object,
   },
   data() {
      return {
         alertBeforeCheckout: false,
         step: 1,
         offersCount: null,
         userMadeSelection: {
            status: false,
            step: null,
         },
         highlightSingle: false,
         showSearchUuids: false,
         showPriceBreakdown: false,
         offerSuccess: false,
      };
   },

   mounted() {
      document.body.addEventListener("keydown", (event) => {
         let held = false;

         if (event.ctrlKey && event.altKey) {
            held = true;
         }

         if (held && event.keyCode == 83) {
            this.showSearchUuids = !this.showSearchUuids;
         }
      });
   },

   methods: {
      PriceBreakdownObj(offer) {
         if (!offer.pricePerLeg) {
            return false;
         } else {
            return "ma";
         }
      },
      InitialToggle(paxCounts) {
         const hasChildOrInfant = "CHILD" in paxCounts || "INFANT" in paxCounts;
         return hasChildOrInfant;
      },
      ShowPaxesBreakdown(paxCounts) {
         const hasChildOrInfant = "CHILD" in paxCounts || "INFANT" in paxCounts;
         return paxCounts.ADULT > 1 || hasChildOrInfant;
      },
      sortedPrices(prices) {
         return Object.keys(prices)
            .filter((key) => key !== "ALL")
            .map((key) => ({ key, value: prices[key] }))
            .concat(Object.prototype.hasOwnProperty.call(prices, "ALL") ? [{ key: "ALL", value: prices["ALL"] }] : []);
      },
      handlerCheckout(searchuuid) {
         window.open(`/flight/checkout/${searchuuid}?uuid=${this.$route.params.uuid}`, "_blank");
      },
      handlerLegToggler() {
         document.querySelectorAll(".leg-tab-detail").forEach((el) => {
            el.classList.toggle("show-leg-tab-detail");
         });
      },
      // handlerOfferType() {
      //    this.step == 0 ? (this.step = 1) : (this.step = 0);
      // },
      handlerDocumentViewer(type, uuid) {
         this.$store.state.app.documentViewer.request.documentType = type;
         this.$store.state.app.documentViewer.request.identifiers = [{ identifier: uuid, subIdentifiers: [] }];
         this.$store.state.app.documentViewer.request.fileType = 2;
         this.$store.state.app.documentViewer.request.uuid = this.$route.params.uuid;
         this.$store.state.app.documentViewer.request.showPrice = false;
         this.$store.state.app.documentViewer.activeProductStatus = 0;
         this.$store.state.app.documentViewer.hasPrice = true;
         this.$store.commit("app/setDocumentViewer", true);
      },
      handlerUserMadeSelection(selection) {
         this.step = selection;

         this.userMadeSelection.status = true;
         if (selection == 0) {
            this.userMadeSelection.step = 0;
         } else if (selection == 1) {
            this.userMadeSelection.step = 1;
         }

         const firstKey = Object.keys(this.basket.offers)[0];
         const tripType = this.basket.offers[firstKey].tripType;

         if (this.offersCount == 1 && tripType == 2) {
            this.$emit("user-selection", 1);
         } else {
            this.$emit("user-selection", this.userMadeSelection.step);
         }
      },
      handlerCheapestOffer(obj) {
         // this.userMadeSelection.step = 0;
         const basketPrices = {
            single: 0,
            package: 0,
         };

         Object.keys(obj.offers).forEach((offer) => {
            if (obj.offers[offer].tripType == 1) {
               basketPrices.single = obj.offers[offer].price;
            } else {
               basketPrices.package = obj.offers[offer].price;
            }
         });

         this.userMadeSelection.step = 1;
         this.step = 1;

         if (basketPrices.single < basketPrices.package) {
            this.highlightSingle = true;
         } else {
            this.highlightSingle = false;
         }

         this.handlerUserMadeSelection(this.step);
      },
      handlerCopySearchUuid(uuid) {
         navigator.clipboard.writeText(uuid);
      },
      handlerCreateOffer() {
         // Get the current offer based on step
         const currentOffer = Object.values(this.basket.offers)[this.step];
         if (!currentOffer) return;

         handleCreateOffer({
            basketUuid: currentOffer.searchUuid,
            entityType: 2, // FLIGHT
            pageSource: 1, // BASKET
            uuid: this.$route.params.uuid,
            $store: this.$store,
            $i18n: this.$i18n,
            onSuccess: () => {
               this.offerSuccess = true;
               setTimeout(() => {
                  this.offerSuccess = false;
               }, 5000);
            },
         });
      },
      handlerBaggageControls(offers) {
         const legObj = {};

         Object.keys(offers).forEach((offer) => {
            legObj[offer] = [];
            Object.keys(offers[offer].legs).forEach((leg) => {
               legObj[offer].push(offers[offer].legs[leg].baggageInfo);
            });
         });

         Object.keys(legObj).forEach((leg, index) => {
            legObj[leg] = legObj[leg].toString();
            if (index != 0) {
               let prevEl = Object.keys(legObj)[0];
               let currentEl = Object.keys(legObj)[index];

               if (legObj[prevEl] != legObj[currentEl]) {
                  this.alertBeforeCheckout = true;
               }
            }
         });

         //    Object.keys(offers).forEach((offer) => {

         //    Object.keys(offers[offer].legs).forEach((leg) => {
         //       legObj[offer].push(offers[offer].legs[leg].baggageInfo);
         //    });
         // });
      },
   },

   watch: {
      basket: {
         handler: function (bskt) {
            if (bskt != null) {
               this.handlerCheapestOffer(bskt);
               this.offersCount = Object.keys(bskt?.offers).length;
               if (this.offersCount == 2) {
                  if (this.userMadeSelection.status) {
                     this.step = this.userMadeSelection.step;
                  } else {
                     this.step = 1;
                  }

                  this.handlerBaggageControls(bskt.offers);
               } else if (this.offersCount == 1) {
                  this.step = 0;
               }
            }
         },
      },
      deep: true,
   },
};
</script>

<style lang="scss" scoped>
.price-breakdown-noprice-view {
   background-color: var(--blue-800);
   color: white;
   padding: 16px;
   border-radius: 8px;

   h3 {
      margin-bottom: 12px;
      font-weight: 600;
   }

   ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
         display: flex;
         justify-content: space-between;
         margin-bottom: 8px;
         font-size: 14px;

         span:last-child {
            font-size: 1rem;
            color: var(--basket-teal);
         }
      }
   }
}
</style>
<style lang="scss">
#flight-basket-desktop {
}
</style>

<style lang="scss" scoped>
#flight-basket-wrapper {
   position: sticky;
   overflow: hidden;
   top: 1rem;
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 1rem;
   height: fit-content;
   width: 100%;
   padding-bottom: 1rem;

   #search-uuids-wrapper {
      position: fixed;
      bottom: 1rem;
      right: 0;
      left: 0;
      margin: auto;
      width: fit-content;
      padding: 0.25rem 0.5rem;
      border-radius: 1rem;
      //background-color: var(--gray-50);
      background-color: var(--gray-0);
      border: 2px solid var(--gray-300);

      .search-uuid {
         margin: 0.125rem;
         cursor: copy;
         color: var(--gray-800);
         font-weight: 500;
         padding: 0.25rem 1rem;
         border-radius: 1rem;

         &:hover {
            background: var(--gray-200);
         }
      }
   }

   .ticket-inner {
      border-radius: 0.5rem;
      background-color: var(--basket-bg);
      width: 100%;

      section.ticket-header {
         position: relative;
         padding: 1.5rem 1.5rem;
         padding-top: 2rem;
         display: flex;
         flex-wrap: wrap;
         justify-content: space-between;

         @media (max-width: 1560px) {
            flex-direction: column;
         }
         cursor: pointer;
         .dotted-line {
            background-image: linear-gradient(to right, var(--gray-200) 33%, var(--gray-0-alpha-90) 0%);
            background-position: left;
            background-size: 12px auto;
            background-repeat: repeat-x;
            display: inline-block;
            width: auto;
            position: absolute;
            bottom: 7px;
            left: 1rem;
            right: 1rem;
            height: 2px;
         }

         &::before,
         &::after {
            content: "*";
            text-indent: -999rem;
            display: block;
            position: absolute;
            width: 16px;
            height: 16px;
            background: var(--background);
            margin: auto;
            bottom: 0;
            border-radius: 50%;
            z-index: 2;
         }

         &::before {
            left: -8px;
         }
         &::after {
            right: -8px;
         }
         h2 {
            font-size: var(--large);
            font-weight: 600;
            color: var(--txt-white);
            display: flex;

            span {
               color: var(--basket-teal) !important;
               font-size: var(--large);
               font-weight: 500;
            }
            .single-display-text {
               margin-left: 0.25rem;
            }
         }

         .basket-type-switch {
            background-color: var(--blue-800);
            padding: 0.25rem;
            border-radius: 12rem;
            display: inline-flex;
            margin-left: 0.25rem;
            justify-content: space-between;
            width: fit-content;
            span {
               color: var(--basket-teal) !important;
               font-size: var(--xsmall);
               font-weight: 600;
               padding: 0.15rem 0.5rem;
               border-radius: 12rem;
               display: flex;
               align-items: center;

               &.active-switch {
                  background-color: var(--basket-teal);
                  color: var(--blue-800) !important;
               }
            }
         }
      }
      .fb-ticket-container {
         padding: 1.5rem;
         padding-bottom: 6rem;
         .basket-offer {
            .cheapest-offer-badge-wrapper {
               margin-bottom: 0.5rem;
               @keyframes switchHighlighter {
                  from {
                     border: 1px solid transparent;
                  }
                  to {
                     border: 1px solid var(--teal-400);
                  }
               }

               @keyframes badgeAnimation {
                  from {
                     top: 25px;
                  }
                  to {
                     top: 0;
                  }
               }

               span.cheapest-offer-badge {
                  cursor: pointer;
                  color: var(--basket-teal);
                  font-weight: 500;
                  position: relative;
                  padding-left: 1.25rem;
                  margin-bottom: 1rem;
                  display: block;
                  animation-name: badgeAnimation;
                  animation-fill-mode: backwards;
                  animation-iteration-count: 1;
                  animation-timing-function: ease-out;
                  animation-duration: 0.25s;

                  @keyframes attention {
                     0% {
                        opacity: 0;
                     }
                     100% {
                        opacity: 1;
                     }
                  }

                  &::before {
                     content: "";
                     opacity: 1;
                     width: 14px;
                     height: 14px;
                     position: absolute;
                     top: 0.35rem;
                     margin: auto;
                     left: 0;
                     border-radius: 50%;
                     background-color: var(--basket-teal);
                     animation-name: attention;
                     animation-fill-mode: backwards;
                     animation-iteration-count: infinite;
                     animation-timing-function: ease-out;
                     animation-duration: 0.75s;
                  }
               }
            }
            .basket-offer-leg-container {
               .basket-offer-leg {
                  padding: 0.5rem 0;
                  border-bottom: 1px solid var(--gray-0-alpha-75);
                  .basket-offer-segment {
                     .basket-offer-segment-infos {
                        display: flex;
                        justify-content: space-between;
                        span {
                           font-weight: 600;
                           font-size: 1.125rem;
                           color: #fff;
                        }

                        i {
                           filter: brightness(10);
                        }
                     }
                     .basket-offer-segment-price {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-top: 0.5rem;

                        @keyframes legInfo {
                           0% {
                              opacity: 0;
                              transform: scale(1);
                           }
                           60% {
                              opacity: 1;
                           }
                           80% {
                              opacity: 1;
                              transform: scale(1);
                           }
                           100% {
                              opacity: 1;
                              transform: scale(1.15);
                           }
                        }
                        span.leg-information {
                           color: var(--basket-teal);
                           font-weight: 500;
                           display: flex;

                           &.attention {
                              animation-name: legInfo;
                              animation-timing-function: ease-out;
                              animation-duration: 1s;
                              animation-iteration-count: infinite;
                           }

                           i {
                              filter: invert(50%) sepia(100%) saturate(180%) hue-rotate(120deg) brightness(100%) contrast(200%);
                           }
                        }
                        span.leg-price {
                           background-color: var(--blue-800);
                           font-size: 1rem;
                           color: var(--txt-white);
                           font-weight: 600;
                           padding: 0.25rem 1rem;
                           border-radius: 24rem;
                        }
                     }
                  }
                  &:last-child {
                     border-bottom: none !important;
                  }
               }
            }
         }
         .action-button-wrapper {
            width: 100%;
            margin: 1rem 0;

            button {
               padding: 0.5rem 1.5rem;
               border-radius: 12rem;
               width: 100%;
               margin: 1rem 0;
               /* box-shadow: var(--gray-500-alpha-50) 0px 2px 8px 0px; */
               box-shadow: var(--gts-box-shadow);
               display: flex;
               align-items: center;
               justify-content: center;
               border: 2px solid var(--blue-800);
               transition: all 0.2s ease-in-out;
               background-color: var(--basket-leg-action-button);

               i {
                  position: relative;

                  margin-right: 0.5rem;
                  transition: all 0.2s ease-in-out;
                  filter: invert(19%) sepia(28%) saturate(5280%) hue-rotate(204deg) brightness(70%) contrast(85%);
                  flex-shrink: 0;
                  transform: scale(1);
                  display: none;
                  @media (min-width: 1700px) {
                     display: block !important;
                  }
               }

               p.total-container {
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  position: relative;
                  top: 0;
                  transition-property: top;
                  transition-timing-function: ease-in-out;
                  transition-duration: 0.2s;
                  .total-text {
                     color: var(--blue-800);
                     font-size: var(--xsmall);
                     font-weight: 600;
                     transition: opacity, 0.2s, ease-in-out;
                     opacity: 1;
                  }
                  .total-price {
                     font-size: 1.25rem;
                     font-weight: 800;
                     color: var(--blue-800);
                  }
               }

               .loader-arrow-wrapper {
                  margin-right: 0.5rem;
                  width: 100%;
                  display: flex;
                  justify-content: center;

                  .g-radial-loader {
                     border-color: var(--primary);
                     border-width: 3px;
                     width: 28px !important;
                     height: 28px !important;
                  }
               }

               &.disabled-action {
               }
            }

            .basket-alertbox-wrapper {
               background-color: var(--gray-1000-alpha-75);
               border-radius: 1rem;
               padding: 1rem;
               display: flex;
               flex-direction: column;
               justify-content: center;
               align-items: center;
               margin-bottom: 1rem;

               i {
                  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICA8ZyBpZD0iR3JvdXBfMTE1MjQiIGRhdGEtbmFtZT0iR3JvdXAgMTE1MjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05NjAuODY4IC03MjMuOTE3KSI+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzEzMTMiIGRhdGEtbmFtZT0iRWxsaXBzZSAxMzEzIiBjeD0iMTQiIGN5PSIxNCIgcj0iMTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk2MC44NjggNzIzLjkxNykiIGZpbGw9IiMwMGZmZTUiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzEwMzY5IiBkYXRhLW5hbWU9IlBhdGggMTAzNjkiIGQ9Ik0xOC42LDE0LjgyM2wtMy43NDMuNDY5LS4xMzQuNjIxLjczNS4xMzZjLjQ4LjExNS41NzUuMjg4LjQ3MS43NjZsLTEuMjA2LDUuNjY5Yy0uMzE3LDEuNDY2LjE3MSwyLjE1NiwxLjMyMSwyLjE1NmEzLjM4NSwzLjM4NSwwLDAsMCwyLjM5NC0uOTc3bC4xNDQtLjY4YTEuODExLDEuODExLDAsMCwxLTEuMTIyLjRjLS40NSwwLS42MTMtLjMxNS0uNS0uODcxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTU4LjMyNSA3MjAuMDc0KSIgZmlsbD0iIzFhM2E2NyIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTAzNzAiIGRhdGEtbmFtZT0iUGF0aCAxMDM3MCIgZD0iTTE5LjAxOSw5LjUxYTEuNjM1LDEuNjM1LDAsMSwxLTEuNjM1LTEuNjM1QTEuNjM1LDEuNjM1LDAsMCwxLDE5LjAxOSw5LjUxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTU4LjAxOCA3MjEuOTc1KSIgZmlsbD0iIzFhM2E2NyIvPgogIDwvZz4KPC9zdmc+Cg==");
                  width: 32px;
                  height: 32px;
                  background-repeat: no-repeat;
                  background-size: cover;
                  display: block;
               }
               span {
                  padding-top: 0.5rem;
                  text-align: center;
                  color: var(--basket-teal);
               }
               #confirm-changes {
                  border: 2px solid var(--blue-500);
                  background-color: var(--blue-700);
                  box-shadow: none;
                  //color: var(--gray-50);
                  color: var(--gray-0);
                  font-weight: 700;
                  font-size: var(--small);

                  &:hover {
                     border-width: 2px !important;
                     background-color: var(--gray-50) !important;
                     color: var(--primary);
                  }
               }
            }

            &:hover {
               button {
                  background-color: var(--blue-800);
                  border: 2px solid var(--blue-800);

                  i {
                     left: -0.1rem;
                     filter: invert(100%) sepia(100%) saturate(10) hue-rotate(160deg) brightness(100%) contrast(200%);
                  }

                  &.disabled-action {
                     cursor: not-allowed;
                     //background-color: var(--gray-50);
                     background-color: var(--gray-0);
                     p.total-container {
                        top: 0px !important;
                        .total-text {
                           color: var(--blue-800);
                           font-size: var(--xsmall);
                           font-weight: 600;

                           opacity: 2;
                        }
                        .total-price {
                           color: var(--blue-800);
                        }
                     }
                  }
               }
               p.total-container {
                  top: -10px;
                  .total-text {
                     color: var(--blue-800);
                     font-size: var(--xsmall);
                     font-weight: 600;

                     opacity: 0;
                  }
                  .total-price {
                     color: var(--basket-teal);
                  }
               }
            }
         }
         .send-offer {
            padding-bottom: 1rem;
            color: var(--txt-white);
            text-align: center;
            width: 100%;
            display: block;
            text-decoration: underline;
            font-size: var(--small);
            cursor: pointer;

            &:hover {
               color: var(--basket-teal);
            }
         }
         .ticket-details-wrapper {
            .leg-offer-wrapper {
               .leg-offer-container {
                  background-color: var(--basket-leg-offer-container);
                  padding: 0.5rem 0.75rem;
                  border-radius: 12px;
                  //color: var(--gray-50);
                  color: var(--gray-0);
                  font-weight: 600;
                  font-size: 1.125rem;
                  margin-bottom: 0.5rem;

                  .leg-tab {
                     .leg-tab-main {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        cursor: pointer;
                        .leg-tab-left {
                           color: var(--txt-white);
                           .leg-number {
                              border-right: 1px solid var(--gray-0-alpha-75);
                              padding-right: 0.35rem;
                              margin-right: 0.35rem;
                           }
                        }
                        .leg-tab-right {
                           i {
                              filter: brightness(10);
                           }
                        }
                     }
                     .leg-tab-detail {
                        padding: 0 0.25rem;
                        margin-top: 1rem;
                        display: none;

                        &.show-leg-tab-detail {
                           display: block;
                        }

                        .leg-tab-detail-row {
                           display: flex;
                           justify-content: space-between;
                           border-bottom: 1px dashed var(--gray-0-alpha-75);
                           padding-bottom: 0.5rem;
                           margin-bottom: 0.5rem;
                           color: var(--txt-white) !important;

                           .leg-tab-detail-leg-route {
                              white-space: nowrap;
                              font-size: 0.85rem;
                              font-weight: 400;
                           }
                           .leg-tab-segment-wrapper {
                              display: flex;
                              flex-direction: column;
                              font-size: 0.85rem;
                              width: 100%;

                              .leg-tab-segment-row {
                                 display: flex;
                                 flex-direction: row;
                                 justify-content: space-between;
                                 width: 100%;
                                 font-weight: 400;

                                 &.opacity {
                                    opacity: 0.6;
                                 }

                                 span {
                                    font-size: var(--xsmall);
                                 }
                              }
                           }
                           &:last-child {
                              border-bottom: none;
                           }
                        }

                        &.display {
                           display: block;
                        }
                        .leg-tab-detail-pax-breakdown {
                           display: flex;
                           flex-direction: column;
                           align-items: flex-end;
                           .leg-tab-detail-pax-breakdown-item {
                              display: grid;
                              grid-template-columns: 1fr 1fr;
                              padding: 0.05rem 0;
                              span {
                                 font-weight: 400 !important;
                                 font-size: 0.9rem;
                                 text-align: right;

                                 &:first-child {
                                    margin-right: 0.5rem;

                                    width: 100%;
                                    display: block;
                                    text-align: left;
                                 }
                                 &:last-child {
                                    min-width: 60px;
                                 }
                                 &.legtotal {
                                    font-size: 1rem;
                                    font-weight: 800 !important;
                                 }
                              }
                           }
                        }
                     }
                  }
               }
            }
         }
      }
   }
}
</style>

<style lang="scss">
#flight-basket-wrapper {
   nav.tabs {
      display: none;
   }
}

.offer-button {
   width: fit-content;
   width: 200px;
   min-height: 50px;
   padding: 0.5rem;
   background-color: #fe6501;
   outline: 4px solid #fe9818;
   border: none;
   border-radius: 10rem;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   transition: all 0.3s ease;
   gap: 0.75rem;

   &:hover {
      transform: scale(1.05);
   }

   &.offer-success {
      background-color: #10b981;
      outline: 4px solid #34d399;
   }

   .offer-button-content {
      display: flex;
      flex-direction: column;
      line-height: 1.125rem;

      .offer-title {
         font-size: var(--normal);
         font-weight: 800;
         color: white;
         text-align: left;
      }

      .offer-subtitle {
         font-size: var(--xsmall);
         color: white;
         opacity: 0.9;
      }
   }
}
</style>
